<div class="app-footer d-flex align-items-center justify-content-between" [class.fixed-bottom]="settings.theme.footerIsFixed">
    <span class="social-icons">
         <!--<a href="https://www.facebook.com/themeseason" target="_blank"><i class="fa fa-facebook-square transition" aria-hidden="true"></i></a>
         <a href="https://twitter.com/themeseason" target="_blank"><i class="fa fa-twitter-square transition" aria-hidden="true"></i></a>
         <a href="https://www.instagram.com/themeseason" target="_blank"><i class="fa fa-instagram transition" aria-hidden="true"></i></a>
         <a href="https://www.pinterest.com/themeseason" target="_blank"><i class="fa fa-pinterest-square transition" aria-hidden="true"></i></a>-->             
    </span>
    <span class="copyright">Copyright © 2021 All Rights Reserved</span>    
</div>
